import { connect } from 'react-redux';
import { TextLink } from '@sbt-web/ancillary-services';
import { Category } from '@sbt-web/category-utils';
import { useViewport } from '@sbt-web/hooks';
import { AdTypes, GeoEntry } from '@sbt-web/network/types';
import type { FiltersConfigState } from '@/reducers/filtersConfig';
import type { RootState } from '@/reducers/index';
import { prepareRemoteDataListing } from '@/shared/helpers/Hebe';
import { getOrCreatePulse } from '@/tools/tracking/utils';

interface TLStateProps {
  adType: AdTypes;
  category: Category;
  filters: { [key: string]: string };
  geo: GeoEntry;
  query: string;
  filtersConfig: FiltersConfigState;
}

interface TLOwnProps {
  page: string;
  max_number_textlinks: number;
}

export function TextLinkBox(props: TLStateProps & TLOwnProps) {
  const {
    adType,
    category,
    filters,
    geo,
    query,
    max_number_textlinks,
    filtersConfig,
  } = props;
  const { isMobile } = useViewport();

  return (
    <TextLink
      pulseInstance={getOrCreatePulse()}
      maxNumberTextlinks={max_number_textlinks}
      remoteData={prepareRemoteDataListing(
        'ADS_FILTERS',
        adType,
        category.id,
        geo,
        filters,
        query,
        isMobile,
        filtersConfig.filtersStore
      )}
    />
  );
}

export default connect<TLStateProps, never, TLOwnProps, RootState>((state) => ({
  adType: state.search.adType,
  category: state.search.category,
  filters: state.search.filters,
  geo: state.search.geo,
  query: state.search.query ?? '',
  filtersConfig: state.filtersConfig,
}))(TextLinkBox);
